import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../routes/AppRoutes';
import { strings } from '../../resources/strings';
import { SessionHelper } from '../../helpers/SessionHelper';
import { ProfileHelper } from '../../helpers/ProfileHelper';
import { useAuth } from '../../contexts/AuthContext';
import { Body } from '../../common-components/Layout/Body/Body';
import { Header } from '../../common-components/Layout/Header/Header';
import { Page } from '../../common-components/Layout/Page/Page';
import { HomeMenuItem } from '../../components/HomeMenuItem/HomeMenuItem';
import { HomeMenu } from '../Home/styles';
import iconNoGrade from '../../assets/icon-no-grade.png';
import iconGrade from '../../assets/icon-grade.png';

const ExpressOrders: React.FC = () => {
  const navigate = useNavigate();
  const { session, signOut } = useAuth();

  useEffect(() => {
    if (!session || SessionHelper.isExpired(session)) {
      signOut(() => {
        navigate(routes.Login);
      });
      return;
    }
  }, [session, navigate]);

  const headerRender = React.useMemo(() => {
    return (
      <Header
        title={strings.ExpressOrders}
        breadcrumbItems={[
          {
            text: strings.Home,
            route: routes.Home
          }
        ]}
        alertSummary={ProfileHelper.profilesThatCanManageTransport.some(p => p === session?.user?.profileType)}
      />
    );
  }, [session]);

  return (
    <Page header={headerRender}>
      <Body marginTop='3px'>
        <HomeMenu>
          <HomeMenuItem
            icon={iconNoGrade}
            subtitle={strings.LogisticsOf}
            title={strings.ExpressOrderNonDegree}
            click={navigateToExpressOrdersNonDegree}
          />
          <HomeMenuItem
            icon={iconGrade}
            subtitle={strings.LogisticsOf}
            title={strings.ExpressOrderWithDegree}
            click={navigateToExpressOrdersWithDegree}
          />
          <HomeMenuItem blank={true} />
        </HomeMenu>
      </Body>
    </Page>
  );

  function navigateToExpressOrdersNonDegree() {
    navigate(routes.ExpressOrdersNonDegree);
  }

  function navigateToExpressOrdersWithDegree() {
    navigate(routes.ExpressOrdersWithDegree);
  }
}

export default ExpressOrders;
